import { ContainerTypeEligibilityContainerTypesType } from "@sellar-io/api-v2/types";
import { ReactNode } from "react";

export const eligibilityTypes: Array<{
  display: string;
  containerType: ContainerTypeEligibilityContainerTypesType;
}> = [
  {
    display: "Plastic kegs",
    containerType: "plasticKeg",
  },
  {
    display: "Steel kegs",
    containerType: "steelKeg",
  },
  {
    display: "Casks",
    containerType: "cask",
  },
];

export const CourierEligibilityRuleTable = ({
  desktop,
  mobile,
  mode,
}: {
  desktop: ReactNode;
  mobile: ReactNode;
  mode: "desktop" | "mobile";
}) => {
  switch (mode) {
    case "desktop":
      return desktop;
    case "mobile":
      return mobile;
    default:
      return null;
  }
};
